import { useEffect } from 'react';
import { AppProviders } from './providers';
import { AppRoutes } from '@/routes';
import { RouteErrorBoundary } from '@/components/errors/RouteErrorBoundary';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { useAppSelector } from '@/hooks/useAppSelector';
import { setInitialized } from '@/store/authSlice';

function AppInitializer({ children }: { children: React.ReactNode }) {
  const dispatch = useAppDispatch();
  const initialized = useAppSelector((s) => s.auth.initialized);

  useEffect(() => {
    dispatch(setInitialized());
  }, [dispatch]);

  if (!initialized) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-600 border-t-transparent" />
      </div>
    );
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <AppProviders>
      <AppInitializer>
        <RouteErrorBoundary>
          <AppRoutes />
        </RouteErrorBoundary>
      </AppInitializer>
    </AppProviders>
  );
}
